import { Link } from 'react-router-dom'

export function NotFoundPage() {
  return (
    <div className="mx-auto flex min-h-[60vh] max-w-xl flex-col items-center justify-center px-4 text-center">
      <p className="font-display text-6xl font-bold text-teal-400/40">404</p>
      <h1 className="mt-4 font-display text-2xl font-bold text-white">Page not found</h1>
      <p className="mt-2 text-white/60">This page doesn't exist yet — or the story hasn't been written.</p>
      <Link to="/" className="cyber-btn-primary mt-8">
        Back to Landing Page
      </Link>
    </div>
  )
}
